import { useEffect, useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const UserFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  mode = "create",
  initialData = null,
  roles = [],
}) => {
  const [form, setForm] = useState({
    //username: "",
    email: "",
    //password: "",
    first_name: "",
    last_name: "",
    phone: "",
    type: null,
  });

  useEffect(() => {
    if (mode === "edit" && initialData) {
      setForm({
        username: initialData.username || "",
        email: initialData.email || "",
        password: "",
        first_name: initialData.first_name || "",
        last_name: initialData.last_name || "",
        phone: initialData.phone || "",
        type: initialData.type ?? null,
      });
    }

    if (mode === "create") {
      setForm({
        //username: "",
        email: "",
        //password: "",
        first_name: "",
        last_name: "",
        phone: "",
        type: null,
      });
    }
  }, [mode, initialData]);

  if (!isOpen) return null;

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(mode === "edit" ? getChangedFields() : form);
  };

  const getChangedFields = () => {
    if (!initialData) return form;

    const changes = {};
    Object.keys(form).forEach((key) => {
      if (form[key] !== initialData[key] && form[key] !== "") {
        changes[key] = form[key];
      }
    });

    return changes;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="w-full max-w-lg bg-slate-900 border border-white/10 rounded-xl shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">
            {mode === "edit" ? "Edit User" : "Add User"}
          </h2>

          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XIcon className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-5 space-y-4">
          {/* {mode === "create" && (
            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Username
              </label>
              <input
                type="text"
                placeholder="username"
                value={form.username}
                onChange={(e) => handleChange("username", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>
          )} */}

          <div>
            <label className="block text-sm text-slate-300 mb-1">Email</label>
            <input
              type="email"
              placeholder="user@example.com"
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          {/* {mode === "create" && (
            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Password
              </label>
              <input
                type="password"
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => handleChange("password", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>
          )} */}

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm text-slate-300 mb-1">
                First Name
              </label>
              <input
                type="text"
                placeholder="First name"
                value={form.first_name}
                onChange={(e) => handleChange("first_name", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>

            <div>
              <label className="block text-sm text-slate-300 mb-1">
                Last Name
              </label>
              <input
                type="text"
                placeholder="Last name"
                value={form.last_name}
                onChange={(e) => handleChange("last_name", e.target.value)}
                className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">
              Phone Number
            </label>
            <input
              type="text"
              placeholder="01700111222"
              value={form.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            />
          </div>

          <div>
            <label className="block text-sm text-slate-300 mb-1">Role</label>
            <select
              value={form.type || ""}
              disabled={!roles.length}
              onChange={(e) =>
                handleChange(
                  "type",
                  e.target.value ? Number(e.target.value) : null
                )
              }
              className="w-full bg-[#131C31] border border-white/10 rounded-lg px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40"
            >
              <option value="">Select role</option>

              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-white/10">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm rounded-lg text-slate-300 hover:bg-slate-800 transition"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            disabled={loading}
            className={`px-4 py-2 text-sm rounded-lg text-white font-medium transition
              ${
                loading
                  ? "bg-pink-400 cursor-not-allowed"
                  : "bg-pink-600 hover:bg-pink-700"
              }
            `}
          >
            {loading
              ? "Saving..."
              : mode === "edit"
              ? "Update User"
              : "Create User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserFormModal;
